import { render, staticRenderFns } from "./inputtemplate.vue?vue&type=template&id=506e0f66&scoped=true&"
import script from "./inputtemplate.vue?vue&type=script&lang=js&"
export * from "./inputtemplate.vue?vue&type=script&lang=js&"
import style0 from "./inputtemplate.vue?vue&type=style&index=0&id=506e0f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e0f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VMenu})
